import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { PageRoutes } from "../../../constants/routes";
import { AuthPasskeyChallengeLoginResponse } from "../../../core/api/requests/auth/passkey_challenge_login/types";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { useWebAuthn } from "../../../hooks/useWebAuthn";
import { AppDispatch } from "../../../store";

export const useLoginPasskey = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { authentication } = useWebAuthn();
  const { state } = useLocation();
  const {
    email,
    payload,
  }: { email: string; payload: AuthPasskeyChallengeLoginResponse } =
    state ?? {};

  useEffect(() => {
    if (!email || !payload) navigateToPage(PageRoutes.LOGIN);
  }, []);

  const handleLoginPasskey = useCallback(async () => {
    dispatch(appActions.showLoading());
    let result;
    try {
      result = await authentication(payload);
    } catch (error) {
      dispatch(appActions.hideLoading());
      dispatch(
        appActions.showModal({
          title: "パスキーでログインできませんでした",
          buttons: [],
        }),
      );
      return;
    }

    const response = result.response;

    dispatch(
      authActions.loginWithPasskey.started({
        passkey_token: payload.passkey_token,
        credential: {
          id: result.id,
          type: result.type,
          raw_id: result.rawId,
          response: {
            client_data_json: response.clientDataJSON,
            authenticator_data: response.authenticatorData,
            signature: response.signature,
            user_handle: response.userHandle ?? "",
          },
        },
        onComplete: () => dispatch(appActions.hideLoading()),
        onSuccess: ({ access_token }) => {
          dispatch(authActions.setIsLoggedIn(true));
          LocalStorageManager.Instance.saveObject(
            AppConfig.Instance.LocalStorageKey["accessToken"],
            access_token,
          );
        },
      }),
    );
  }, []);

  const handleCancel = useCallback(() => {
    navigateToPage(PageRoutes.LOGIN_PASSWORD, undefined, { email });
  }, []);

  return { handleLoginPasskey, handleCancel };
};
